module.exports = __webpack_public_path__ + "media/tema_2.1_comparative_equiality_karen_cf1.ade8d46a.wav";